import React from "react";
import styles from "../../../../styles/AdminConsole.module.css";

/**
 * SelectWrapper
 *
 * A styled <select> with the chevron overlay your CSS expects.
 * Accepts every native <select> prop plus an optional `wrapperClassName`.
 *
 * Props:
 *   value             string
 *   onChange          (e) => void
 *   disabled          bool
 *   wrapperClassName  string   — extra class on the outer div
 *   selectClassName   string   — extra class on the <select>
 *   children          <option> / <optgroup> elements
 *
 * Usage:
 *   <SelectWrapper value={category} onChange={(e) => setCategory(e.target.value)}>
 *     <option value="woven">Woven</option>
 *     <option value="knitted">Knitted</option>
 *   </SelectWrapper>
 */
const SelectWrapper = React.memo(function SelectWrapper({
  value,
  onChange,
  disabled = false,
  wrapperClassName = "",
  selectClassName = "",
  style,
  children,
}) {
  return (
    <div className={`${styles.selectWrapper} ${wrapperClassName}`}>
      <select
        className={`${styles.input} ${selectClassName}`}
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={style}
      >
        {children}
      </select>
      <span className={styles.selectChevron}>▾</span>
    </div>
  );
});

export default SelectWrapper;
